<footer class="app-footer">
  <img class="footer-eu-logo" src="../../../assets/img/europe_funded.png" alt="EU flag">
  <p class="footer-text">
    HSbooster.eu has received funding from the EU’s Horizon Europe research and innovation programme under Grant Agreement no. 101058391
  </p>
</footer>
